export default function verified({ to, next, store }) {
  const verifyEmailQuery = { path: '/verify-email', query: { redirect: to.fullPath } };

  if (!store.state.auth.user?.attributes.verified) {
    next(verifyEmailQuery);
  } else {
    next();
  }
}
